import { defineMessages } from 'react-intl';

const newHelpMessages = defineMessages({
  headerTitle: {
    id: 'help.headerTitle',
    defaultMessage: 'What can we help you with?',
    description: 'Main header of the help page.',
  },
  sectionSingingIn: {
    id: 'newHelp.sectionSingingIn',
    defaultMessage: 'Signing in',
    description: 'Signing in  section header of the help page.',
  },
  sectionAccountLinking: {
    id: 'newHelp.sectionAccountLinking',
    defaultMessage: 'Linking a new sign-in method to your profile',
    description: 'Account linking section header of the help page.',
  },
  sectionGettingStarted: {
    id: 'newHelp.sectionGettingStarted',
    defaultMessage: 'Getting Started with the Sign-In Page',
    description: 'Getting started section header for simplified login help.',
  },
  sectionSigningInToAccount: {
    id: 'newHelp.sectionSigningInToAccount',
    defaultMessage: 'Signing In to Your Account',
    description: 'Signing in section header for simplified login help.',
  },
  sectionNewUsers: {
    id: 'newHelp.sectionNewUsers',
    defaultMessage: 'New Users: Creating an Account',
    description: 'New users section header for simplified login help.',
  },
  sectionSocialSignIn: {
    id: 'newHelp.sectionSocialSignIn',
    defaultMessage: 'Social Sign-In',
    description: 'Social sign-in section header for simplified login help.',
  },
  sectionOrgSSO: {
    id: 'newHelp.sectionOrgSSO',
    defaultMessage: 'Organizational Single Sign On',
    description: 'Org SSO section header for simplified login help.',
  },
  sectionTroubleshooting: {
    id: 'newHelp.sectionTroubleshooting',
    defaultMessage: 'Troubleshooting',
    description: 'Troubleshooting section header for simplified login help.',
  },
  sectionStillNeedHelp: {
    id: 'newHelp.sectionStillNeedHelp',
    defaultMessage: 'Still Need Help?',
    description: 'Still need help section header for simplified login help.',
  },
  sectionConnectedAccounts: {
    id: 'newHelp.sectionConnectedAccounts',
    defaultMessage: 'Connected Accounts FAQ',
    description: 'Connected accounts section header for simplified login help.',
  },
  subsectionConnectingAccounts: {
    id: 'newHelp.subsectionConnectingAccounts',
    defaultMessage: 'Connecting Accounts',
    description: 'Connecting accounts subsection header.',
  },
  subsectionDisconnectingAccounts: {
    id: 'newHelp.subsectionDisconnectingAccounts',
    defaultMessage: 'Disconnecting Accounts',
    description: 'Disconnecting accounts subsection header.',
  },
  subsectionSecurityAndPrivacy: {
    id: 'newHelp.subsectionSecurityAndPrivacy',
    defaultMessage: 'Security and Privacy',
    description: 'Security and privacy subsection header.',
  },
});

export default newHelpMessages;
